module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db centered-container-ns inter lh-copy"
  }, [_c('akko-header'), _vm._v(" "), _c('div', {
    staticClass: "bg-white shadow-theme-ns ph3 ph4-ns mt6 mt0-ns pv5-ns br1-ns tc",
    attrs: {
      "id": "complete-card"
    }
  }, [_c('div', {
    staticClass: "mv4"
  }, [_vm._v("\n      Great! You've successfully registered your AKKO Plan and will now proceed to add the items you want protected.\n    ")]), _vm._v(" "), (!_vm.user.is_verified) ? _c('div', {
    staticClass: "mv4"
  }, [_vm._v("\n      Please don't forget to verify your phone number by clicking the link in the SMS sent to you from \"AKKO\".\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_vm._v("\n      Now click the button below to continue to your account dashboard.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_vm._v("\n      From there, set your password by clicking the \"update password\" notice and then continue to the \"items\" section to add your items to your plan!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 mh3 center-ns"
  }, [_c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": "/"
    }
  }, [_c('ak-button', {
    attrs: {
      "primary": "",
      "block": ""
    }
  }, [_vm._v("Continue")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_vm._v("\n      To request modifications to your plan or upgrade, go to your \"account settings\" and click \"change plan\".\n    ")]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt4 mb3 tc"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_vm._v("If you need help or have any questions, just contact us!")]), _vm._v(" "), _c('a', {
    staticClass: "no-underline db mv1",
    attrs: {
      "href": "mailto:support@getakko.com"
    }
  }, [_vm._v("\n        Email\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d0af00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activation/ActivateAccount.vue
// module id = 1240
// module chunks = 0